
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"currentColor","stroke-width":"1.5","transform":"translate(-3 -3)"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"4.393"}}),_c('path',{attrs:{"stroke-dasharray":"8.05","stroke-linecap":"round","d":"M6.544 17.85a8 8 0 1010.912-11.7 8 8 0 00-10.912 11.7z"}}),_c('path',{attrs:{"d":"M16 19h6m-3-3v6"}})])])
          )
        }
      }
    